import {Box, Tab, Tabs} from '@mui/material';
import {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

interface TabMenuProps {
  tabs: Array<{to: string; label: string; icon: React.ReactElement}>;
}

export default function TabMenu({tabs}: TabMenuProps) {
  const location = useLocation();
  const [value, setValue] = useState(tabs.find(v => v.to === location.pathname)?.to || tabs[0].to);

  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <div>
      <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
        <Tabs
          value={value}
          onChange={handleChange}
          sx={{
            minHeight: '36px',
            '& .MuiTabs-scroller': {
              overflowX: 'auto',
            },
            '& .MuiTabs-indicator': {
              backgroundColor: 'primary.main',
            },
            '& .MuiTab-root': {
              minWidth: 'auto',
              padding: {xs: '6px 8px', sm: '6px 12px'},
              fontSize: {xs: '0.75rem', sm: '0.875rem'},
              textTransform: 'none',
            },
            '& .MuiTab-root.Mui-selected': {
              color: 'primary.main',
            },
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          {tabs.map(({to, label, icon}) => (
            <Tab
              key={to}
              value={to}
              label={label}
              icon={icon}
              iconPosition="start"
              onClick={() => {
                navigate(to);
              }}
              sx={{
                paddingY: 0,
                minHeight: '100%',
                whiteSpace: 'nowrap',
                flexShrink: 0,
              }}
            />
          ))}
        </Tabs>
      </Box>
    </div>
  );
}
